<template>
  <div class="floating-header">
    <a href="/" class="header-link">
      <StarIcon :size="20" custom-class="header-star" />
      <h1>PICKYTHING</h1>
    </a>
  </div>
</template>

<script>
import StarIcon from "@/components/StarIcon.vue";

export default {
  name: "FloatingHeader",
  components: {
    StarIcon
  }
};
</script>

<style scoped>
.floating-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 5px;
  background-color: #ffffff; /* Set your desired background color */
  border-bottom: 1px solid #ccc; /* Add a border for separation */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* Add a subtle box shadow */
  display: flex;
  align-items: center;
}

.header-link {
  text-decoration: none; /* Remove the default underline for links */
  color: inherit; /* Inherit the text color */
  display: flex;
  align-items: center;
}

.header-star {
  margin-right: 5px; /* Add some margin for spacing */
  margin-left: 10px;
  display: flex;
  align-items: center;
}

h1 {
  font-size: 18px;
  line-height: 1.2;
  margin: 0;
  display: flex;
  align-items: center;
}
</style>